// /src/store/common/getters.js
import { pStore } from '@/services/Storage'
import _find from 'lodash/find'

// all getters require state property you desire to get
// Also these getters require data property as an array
export default {
  getTypeInfo: function() {
    return routePath => {
      let stateItem = {}
      // switched to pStore.configs from state so we didn't have to wait on API requests
      Object.values(pStore.configs).forEach(value => {
        if (
          typeof value.routePath != 'undefined' &&
          value.routePath == routePath
        ) {
          stateItem = value
          return
        }
      })
      if (Object.keys(stateItem).length > 0) {
        stateItem = Object.assign({}, stateItem)
        delete stateItem.data
        return stateItem
      }
      return false
    }
  },
  getState: function(state) {
    return stateProp => {
      return state[stateProp].data
    }
  },
  getAll: function(state) {
    return stateProp => {
      return state[stateProp].data
    }
  },
  getRange: function(state) {
    return (stateProp, start = 0, end = 9) => {
      // passing -1 into end will pull the rest of items
      return state[stateProp].data.slice(start, end)
    }
  },
  findItemsByIDArray: state => (stateProp, array = [0], key = 'id') => {
    // passing array of IDs
    const collection = []
    let i = 0
    do {
      const id = parseInt(array[i])
      const propData = state[stateProp].data
      const item = _find(propData, item => item[key] == id)
      if (typeof item != 'undefined') collection.push(item)
      i++
    } while (i < array.length)
    return collection
  },
  filterItemsByProp: function(state) {
    return async (stateProp, value, key = 'id') => {
      const queryValue = key == 'id' ? parseInt(value) : value
      // const data = await state[stateProp].data
      return await state[stateProp].data.filter(item => item[key] === queryValue)
    }
  },
  findItemByProp: function(state) {
    return (stateProp, value, key = 'id') => {
      // console.log({'findItemByProp stateProp': stateProp})
      // console.log({'findItemByProp stateItem': state[stateProp]})
      // console.log(state['sessions'].data.find(item => item[key] === 898))
      const data = state[stateProp].data
      return data.find(item => {
        // console.log({'findItemByProp item': item})
        // console.log({'findItemByProp key': key})
        // console.log({'findItemByProp value': item[key]})
        // console.log({'findItemByProp looking value': value})
        return item[key] === value
      })
    }
  },
}
